export const MAX_LANDING_RECENTS = 20
export const LANDING_SPACING = '0.5rem'
export const LANDING_COLUMN_GAP = '1.25rem'
export const SCROLL_FADE_HEIGHT = '1.5rem'
export const SCROLLBAR_WIDTH = '0.5rem'
export const SCROLLBAR_GUTTER = '0.5rem'
export const SCROLLBAR_LANE = `calc(${SCROLLBAR_GUTTER} + ${SCROLLBAR_WIDTH})`
